/**
 Blocks lays out the blocks in a section based on sectionType
 */

import React, { Component } from 'react'
import Block from './Block'
import { Row, Column, ThreeColumnGrid, FourColumnGrid } from '../Grid'

export default class Blocks extends Component {
  render() {
    const { sectionType, data, brain } = this.props
    if (!data) return null
    // console.log('sectionType: ', sectionType)
    // console.log('data: ', data)

    function sectionTypeSwitch() {
      switch (sectionType) {
      case 'Padded Single-Column': {
        return (
          <Row sectionType={sectionType}>
            <Column sectionType={sectionType}>
              {
                data.map((block, index) => (
                  <Block brain={brain} key={index} data={block} />
                ))
              }
            </Column>
          </Row>
        )
      }
      case 'Three Column Grid': {
        return (
          <ThreeColumnGrid>
            {
              data.map((block, index) => (
                <Block brain={brain} key={index} data={block} />
              ))
            }
          </ThreeColumnGrid>
        )
      }
      case 'Four Column Grid': {
        return (
          <FourColumnGrid>
            {
              data.map((block, index) => (
                <Block brain={brain} key={index} data={block} />
              ))
            }
          </FourColumnGrid>
        )
      }
      default: {
        if (data.length === 2) {
          // default for 2 blocks is half and half flex layout
          // ordering is determined by order of content block
          // in contentful rather than layout type like a section
          return (
            <Row>
              {
                data.map((block, index) => (
                  <Column key={index}>
                    <Block brain={brain} data={block} />
                  </Column>
                ))
              }
            </Row>
            )
          }
        else { // default just display it in outer container
            return data.map((block, index) => (
              <div key={index}>
                <Block brain={brain} data={block} />
              </div>
              )
            )
          }
        }
      }
    }

    return sectionTypeSwitch()
  }
}
